import { createContext } from "react";
export var SchedulerDataContext = createContext(null);
